module.exports = __webpack_public_path__ + "static/media/smart_recruiters_logo.fd6053b7.png";